"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { posterType } from "@/app/career/view-jobs/[id]/type";
import styles from "../../../styles.module.scss";
import { useTranslation } from "react-i18next";
import PosterProfileAction from "../../../JobSource/PosterProfileAction";
function ExpiredJobSource(t0) {
  const $ = _c(22);
  const {
    posterInfo
  } = t0;
  const {
    t
  } = useTranslation();
  const t1 = posterInfo?.posterProfilePicture || "";
  let t2;
  if ($[0] !== t1) {
    t2 = <div className="flex-grow-0 flex-shrink-0 w-20 h-20 mr-2.5"><Image src={t1} alt="poster profile picture" unoptimized={true} width={88} height={88} /></div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("Quelle");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = posterInfo?.jobSource;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <p className="appearance-none text-b2c-regular-body text-real-green font-regular uppercase">{t3}: {t4}</p>;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t("Ver\xF6ffentlicht durch");
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <p className="text-b2c-regular-body text-black font-regular font-lato mt-auto">{t6}:</p>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = posterInfo?.postedName;
  const t9 = posterInfo?.posterProfileUrl;
  const t10 = posterInfo?.confidentialPoster;
  let t11;
  if ($[11] !== t10 || $[12] !== t8 || $[13] !== t9) {
    t11 = <PosterProfileAction className={styles.link} postedName={t8} posterProfileUrl={t9} confidentialPoster={t10} />;
    $[11] = t10;
    $[12] = t8;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t5 || $[17] !== t7) {
    t12 = <div className="flex-grow-1 flex-shrink-1 flex flex-col">{t5}{t7}{t11}</div>;
    $[15] = t11;
    $[16] = t5;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t2) {
    t13 = <div className={`${styles.jobSource} ${styles.card}`}>{t2}{t12}</div>;
    $[19] = t12;
    $[20] = t2;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}
export default ExpiredJobSource;